import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = ({ data }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [intro, setIntro] = useState("");

  if (data) {
    // var contactName = data.name;
    // var street = data.address.street;
    // var city = data.address.city;
    // var state = data.address.state;
    // var zip = data.address.zip;
    // var phone = data.phone;
    //var contactEmail = data.email;
    var contactMessage = data.contactmessage;
  }

  const SERVICE_ID = "service_9mjv8dp";
  const TEMPLATE_ID = "template_61u8nte";
  const PUBLIC_KEY = '650BYODtC9KJw0_O2'

  const submitForm = (e) => {
    e.preventDefault();

    var templateParams = {
      from_name: name, 
      from_email: email,
      from_contact: contact,
      from_age: age,
      from_gender: gender,
      from_intro: intro,
    };

    emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY).then(
      (response) => {
        console.log("SUCCESS!", response.status, response.text);
        setName("");
        setEmail("");
        setContact("");
        setAge("");
        setGender("");
        setIntro("");
      },
      (error) => {
        console.log("FAILED...", error);
      }
    );
  };

  return (
    <section id="contact">
      <div className="row section-head">
        <div className="two columns header-col">
          <h1>
            <span>Get In Touch.</span>
          </h1>
        </div>

        <div className="ten columns">
          <p className="lead">{contactMessage}</p>
        </div>
      </div>

      <div className="row">
        <div className="eight columns">
          <form onSubmit={submitForm}>
            <fieldset>
              <div>
                <label htmlFor="contactName">
                  Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  defaultValue=""
                  value={name}
                  size="35"
                  id="contactName"
                  name="contactName"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div>
                <label htmlFor="contactEmail">
                  Email <span className="required">*</span>
                </label>
                <input
                  type="text"
                  defaultValue=""
                  value={email}
                  size="35"
                  id="contactEmail"
                  name="contactEmail"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div>
                <label htmlFor="contactNumber">
                  Contact <span className="required">*</span>
                </label>
                <input
                  type="tel"
                  defaultValue=""
                  value={contact}
                  maxLength={10}
                  id="contactNumber"
                  name="contactNumber"
                  onChange={(e) => setContact(e.target.value)}
                />
              </div>

              <div>
                <label htmlFor="contactAge">
                  Age <span className="required">*</span>
                </label>
                <input
                  type="number"
                  defaultValue=""
                  value={age}
                  max={99}
                  min={15}
                  id="contactAge"
                  name="contactAge"
                  onChange={(e) => setAge(e.target.value)}
                />
              </div>

              <div>
                <label htmlFor="contactGender">
                  Gender <span className="required">*</span>
                </label>
                <input
                  type="text"
                  defaultValue=""
                  value={gender}
                  size="10"
                  id="contactGender"
                  name="contactGender"
                  onChange={(e) => setGender(e.target.value)}
                />
              </div>

              <div>
                <label htmlFor="contactIntro">
                  Intro Video Link <span className="required">*</span>
                </label>
                <input
                  type="text"
                  defaultValue=""
                  value={intro}
                  size="50"
                  id="contactIntro"
                  name="contactIntro"
                  onChange={(e) => setIntro(e.target.value)}
                />
              </div>

              <div>
                <button onClick={submitForm} type="submit" className="submit">
                  Submit
                </button>
              </div>
            </fieldset>
          </form>

          <div id="message-warning"> Error boy</div>
          <div id="message-success">
            <i className="fa fa-check"></i>Your message was sent, thank you!
            <br />
          </div>
        </div>

        {/* <aside className="four columns footer-widgets">
          <div className="widget widget_contact">
            <h4>Address and Phone</h4>
            <p className="address">
             
            </p>
          </div>
        </aside> */}
      </div>
    </section>
  );
};

export default Contact;
